import _ from 'underscore';
import Backbone from 'backbone';
import template from '../template/index.pug';

export type InlineAlertType = 'info' | 'warning' | 'danger' | 'success';

export interface InlineAlertViewOptions {
  defaultType: InlineAlertType;
  defaultContent: string;
  defaultShow?: boolean;
  defaultSkipEncoding?: boolean;
}

export interface InlineAlertState {
  type: InlineAlertType;
  content: string;
  show: boolean;
  skipEncoding: boolean;
}

export type InlineAlertStateUpdate = Partial<InlineAlertState>;

/**
 * View for the inline alert.
 * @param {string} defaultType - the default type of the alert, accepting 'info', 'warning', 'danger' and 'success'
 * @param {string} defaultContent - the default localized content to display in the alert view
 * @param {bool} defaultShow - the default display state of the alert view
 * @param {bool} defaultSkipEncoding - the default skipping of encoding the content
 * use setState({ type, content, show }) to set new state of the alert
 */
export class InlineAlertView extends (Backbone.View as unknown as new (
  options: InlineAlertViewOptions
) => Pick<Backbone.View<Backbone.Model>, '$el'> & { model: InlineAlertState }) {
  initialize({
    defaultType,
    defaultContent,
    defaultShow = true,
    defaultSkipEncoding = false,
  }: InlineAlertViewOptions) {
    this.model = {
      type: defaultType,
      content: defaultContent,
      show: defaultShow,
      skipEncoding: defaultSkipEncoding,
    };
  }

  className() {
    return 'inline-alert-container';
  }

  setState(state: InlineAlertStateUpdate) {
    _.extend(this.model, state);

    return this.render();
  }

  render() {
    this.$el.html(template(this.model));

    return this;
  }
}
